/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a YouTube video link and instantly grab its thumbnail in every available resolution. Preview each size, then download or copy the image URL.`)
};

const es_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega el enlace de un video de YouTube y obtén al instante su miniatura en todas las resoluciones disponibles. Previsualiza cada tamaño y luego descarga o copia la URL de la imagen.`)
};

const de_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge einen YouTube-Video-Link ein und hol dir sofort das Thumbnail in jeder verfügbaren Auflösung. Sieh dir jede Größe in der Vorschau an und lade sie herunter oder kopiere die Bild-URL.`)
};

const nl_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een YouTube-videolink en haal direct de thumbnail op in elke beschikbare resolutie. Bekijk elk formaat vooraf en download de afbeelding of kopieer de URL.`)
};

const fr_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez le lien d’une vidéo YouTube et récupérez instantanément sa miniature dans toutes les résolutions disponibles. Prévisualisez chaque taille, puis téléchargez ou copiez l’URL de l’image.`)
};

const it_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il link di un video YouTube e ottieni istantaneamente la sua miniatura in ogni risoluzione disponibile. Visualizza l'anteprima di ogni dimensione, poi scarica o copia l'URL dell'immagine.`)
};

const pt_br2_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o link de um vídeo do YouTube e pegue instantaneamente a thumbnail em todas as resoluções disponíveis. Visualize cada tamanho e depois baixe ou copie a URL da imagem.`)
};

const pt_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o link de um vídeo do YouTube e obtenha instantaneamente a sua miniatura em todas as resoluções disponíveis. Pré-visualize cada tamanho e depois descarregue ou copie o URL da imagem.`)
};

const ja_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube動画のリンクを貼り付けると、利用可能なすべての解像度でサムネイルを即座に取得できます。各サイズをプレビューし、画像をダウンロードまたはURLをコピーしましょう。`)
};

const zh_yt_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 YouTube 视频链接，即可立即获取其所有可用分辨率的缩略图。预览每种尺寸，然后下载或复制图片链接。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_intro", locale)
	if (locale === "en") return en_yt_hub_intro(inputs)
	if (locale === "es") return es_yt_hub_intro(inputs)
	if (locale === "de") return de_yt_hub_intro(inputs)
	if (locale === "nl") return nl_yt_hub_intro(inputs)
	if (locale === "fr") return fr_yt_hub_intro(inputs)
	if (locale === "it") return it_yt_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_intro(inputs)
	if (locale === "pt") return pt_yt_hub_intro(inputs)
	if (locale === "ja") return ja_yt_hub_intro(inputs)
	return zh_yt_hub_intro(inputs)
};